import firebase from "firebase"
import "firebase/firestore"

// firebase init goes here
const config = {
  apiKey: "AIzaSyCbB-7CihyBpgzM7p_vmKeA2QQOcmBEH2M",
  // authDomain: 'btc-entry-suscc.firebaseapp.com',
  authDomain: "bldg-screen.web.app",
  projectId: "bldg-screen"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// firebase collections
const profileCollection = db.collection('profiles')
const waiverCollection = db.collection('waivers')
const surveyCollection = db.collection('surveys')
const visitorCollection = db.collection('visitors')

export {
    db,
    auth,
    currentUser,
    profileCollection,
    waiverCollection,
    surveyCollection,
    visitorCollection
}